import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import ReactJwtDecode from 'jwt-decode';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Layout from '../../../components/mui/Layout';
import FirmanteComponent from './components/Firmante';
import isNotEmptyValue from '../../../helpers/isNotEmptyValue';
import Feedback from '../../../components/mui/Feedback'

const HomePage = () => {
  const accessToken = useSelector(({ auth }) => auth.accessToken);
  const [isLoading, setIsLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState('1');
  const [pathPdf, setPathPdf] = useState('');
  const [arrayFirmantes, setArrayFirmantes] = useState([]);

  useEffect(() => {
    if (currentTab === '1') {
      handleLoadFirmantes();
    } else {
      handleLoadPdfJs();
    }
  }, [currentTab]);

  const handleLoadFirmantes = () => {
    setIsLoading(true);

    setTimeout(() => {
      if (isNotEmptyValue(accessToken)) {
        const decode = ReactJwtDecode(accessToken);

        if (isNotEmptyValue(decode?.policy?.firmantes)) {
          setArrayFirmantes(decode.policy.firmantes);
        }
      }

      setIsLoading(false);
    }, 2000);
  }

  const handleLoadPdfJs = () => {
    setIsLoading(true);

    setTimeout(() => {
      if (isNotEmptyValue(accessToken)) {
        const decode = ReactJwtDecode(accessToken);

        if (process.env.REACT_APP_CERTIFY_TYPE === 'certificados') {
          if (isNotEmptyValue(decode?.policy?.contract)) {
            setPathPdf(decode.policy.contract);
          }
        } else {
          if (isNotEmptyValue(decode?.policy?.pagare)) {
            setPathPdf(decode.policy.pagare);
          }
        }
      }

      setIsLoading(false);
    }, 2000);
  }

  const handleChange = (event, newValue) => setCurrentTab(newValue);

  return (
    <Layout.Page title="Home">
      <div className="row mt-4 d-flex align-items-center align-content-center justify-content-center">
        <div className='col-sm-12 col-md-10 col-lg-8'>
          <TabContext value={currentTab}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleChange} aria-label="lab API tabs example">
                <Tab label="Firmantes" value="1" />
                <Tab label={process.env.REACT_APP_TAB_PREVIEW} value="2" />
              </TabList>
            </Box>
            <TabPanel value="1">
              {arrayFirmantes.length > 0 && !isLoading && (
                arrayFirmantes.map((item, index) => (
                  <FirmanteComponent
                    key={index}
                    data={item}
                  />
                ))
              )}
            </TabPanel>
            <TabPanel value="2">
              {pathPdf !== '' && !isLoading && (
                <embed
                  alt="pdf"
                  height="600"
                  pluginspage="http://www.adobe.com/products/acrobat/readstep2.html"
                  src={pathPdf}
                  type="application/pdf"
                  width="100%"
                ></embed>
              )}
            </TabPanel>
          </TabContext>
        </div>
      </div>
      <Feedback.ModalLoading
        isOpen={isLoading}
        title='Cargando...'
        content='Espere un momento por favor...'
      />
    </Layout.Page>
  );
};

export default HomePage;
